module.exports = __webpack_public_path__ + "static/media/url_link.7073ae2353d226673884af8bdb525656.svg";